<section class="rooftop" id="rooftop">

  <!-- Bottom: amenities gallery band -->
  <div class="rooftop-amenities">
    <div class="rooftop-amenities-text reveal">
      <p class="rooftop-amenities-eyebrow">A Private Reserve in the Sky</p>
      <h3 class="rooftop-amenities-title">
        A Private Reserve<br>in the Sky
      </h3>
      <p class="rooftop-amenities-body">
        Rising twenty-three stories high, the crown of ACACIA unfolds as
        a series of elevated sanctuaries, each one designed for renewal,
        reflection, and refined leisure. An infinity pool flows along the
        skyline, framed by a yoga pavilion, holistic spa, and sky garden.
        Day and night, this is the resident's private reserve, where the
        drama of the city meets the calm of the savanna.
      </p>
    </div>

    <div class="rooftop-gallery reveal reveal-delay-2" #lgContainer>

      @for (img of images; track img.src; let i = $index) {
        <button
          type="button"
          class="rooftop-gallery-thumb"
          (click)="openAt(i)"
          [attr.aria-label]="img.alt"
        >
          <img [src]="img.src" [alt]="img.alt" loading="lazy" />
          <span class="rooftop-thumb-overlay">
            <span class="rooftop-thumb-label">{{ img.label }}</span>
            <svg class="rooftop-thumb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
            </svg>
          </span>
        </button>
      }
    </div>
  </div>

</section>
